import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'http://localhost:8000',
  baseURL: 'https://dashboard-back.spidergolf.fr',
  timeout: 300000,
  // Auth tokens live in httpOnly cookies now, not a header we set manually
  // (see jwtService.js) -- the browser needs this to actually send them.
  withCredentials: true,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
